export enum FilterType {
  name = 'name',
  role = 'role',
  department = 'department',
  team = 'team',
  branch = 'branch'
}
